/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Advantages_HeadingInputs */

const en_homepage_advantages_heading = /** @type {(inputs: Homepage_Advantages_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatically skip citations, references, and footnotes`)
};

const es_homepage_advantages_heading = /** @type {(inputs: Homepage_Advantages_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omite automáticamente citas, referencias y notas al pie`)
};

/**
* | output |
* | --- |
* | "Automatically skip citations, references, and footnotes" |
*
* @param {Homepage_Advantages_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_advantages_heading = /** @type {((inputs?: Homepage_Advantages_HeadingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Advantages_HeadingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_advantages_heading(inputs)
	return en_homepage_advantages_heading(inputs)
});